let logger = require("logger");

export default {
    showToast: () => {
        logger.log("Toastmaker not loaded yet")
    }
}